import { useState } from "react"
import { useNavigate } from "react-router-dom"
import Alert from "../components/common/Alert"
import Message from "../utils/Message"
import axios from "axios"
import useAuthTank from "../components/hooks/useAuthTank"

const AuthTank = () => {
	const [password, setPassword] = useState('')
	const [alert, setAlert] = useState({})

	const navigate = useNavigate()
	const {setAuth} = useAuthTank()

	const handlerSubmit = async (e) => {
		try {
			e.preventDefault()
			const enterPassword = Message.ENTER_PASSWORD
			if (!password) {
				setAlert({
					msg: enterPassword,
					error: true
				})
				return
			}
			const {data} = await axios.post(
				`${process.env.REACT_APP_URL_SERVER}/user-tank/login`,
				{
					password
				}
			)
			setAlert({})
			sessionStorage.setItem('token-tank', data.tokenJwt)
			setAuth(data)
            navigate('/dashboard-tank')
		} catch (error) {
			setAlert({
				msg: error.response.data.msg,
				error: true
			})
		}
	}

	return (
		<div className="authtank col-12 col-sm-9 position-absolute top-50 start-50 translate-middle">
			<form
				className="form-authtank"
				onSubmit={handlerSubmit}
			>
				<h1 className="h1-authtank">Login Acopio</h1>
				<div className="form-outline mb-4">
					{alert.msg && <Alert alert={alert}></Alert>}
					<label
						className="label-authtank form-label"
						htmlFor="password"
					>Contraseña:</label>
					<input
						type="password"
						id="password"
						className="password-authtank form-control"
						placeholder="¡Ingresa tu contraseña!"
						value={password}
						onChange={e => setPassword(e.target.value)}
					/>
				</div>
				<button
					type="submit"
					className="btn-authtank btn btn-primary btn-block mb-4"
				>Ingresar</button>
			</form>
		</div>
	)
}

export default AuthTank